import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

const LANGS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => i18n.language?.startsWith(l.code)) || LANGS[0];

  const changeLang = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem('ofb_language', code); } catch (e) {}
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="gap-1 sm:gap-2 text-xs sm:text-sm px-2 sm:px-3"
          data-testid="language-switcher"
        >
          <Globe className="w-4 h-4" />
          <span className="hidden sm:inline">{current.flag} {current.code.toUpperCase()}</span>
          <span className="sm:hidden">{current.code.toUpperCase()}</span>
          <ChevronDown className="w-3 h-3 sm:w-4 sm:h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-[60]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => changeLang(l.code)}
            className={current.code === l.code ? 'bg-primary/10' : ''}
            data-testid={`lang-option-${l.code}`}
          >
            <span className="mr-2">{l.flag}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
